import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../../utils/apolloClient';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';
const { DMS_ACCOUNT_TYPES_MAPPING } = require('../../../components/stepper/stepperBody/stepperBodyComponents/DMSSelectionComponents/utils/constant');

const initialState = {
  selectedDMS: [],
  isEISDMSInfoPending: false,
  isEISDMSInfoSuccess: false,
  getEISDMSInfo: [],
  isEISDMSInfoLoading: false,
  errorInGetEISDMSInfo: null,
  updatedSelectedLocations: [],
  updatedSelectedAllLocations: [],
  DMSConfigInfo: [],
  dmsApiDetails: {},
  getDMSInfoBasedOnApisPending: true,
  getDMSInfoBasedOnApisError: null,
  showAllLocations: [],
  privacyProtectionSupported: {},
  verticalScopingApisList: [],
  dmsSupported: {},
  dealerApiPreferences: {},
  verticalScopingSupported: {}
};

export const getDMSAccountDetailsFromEIS = createAsyncThunk(
  'getDMSAccountDetailsFromEIS',
  async ({ cmfNumber, storeId, token, location, entityId, dmsApiDetails }) => {
    const response = await client.authorizeRequest({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/v1/connectCDK/${storeId}`
    });
    return {
      data: response.data,
      location,
      cmfNumber,
      storeId,
      entityId,
      dmsApiDetails
    };
  }
);

export const getDMSInfoBasedOnApis = createAsyncThunk(
  'getDMSInfoBasedOnApis',
  async ({apis, token, appId, caller} ) => {
    const response = await client.authorizeRequest({
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/v2/systemInfo`,
      data: {
        apis,
      ...(environmentURLs.REACT_APP_SHOW_VERTICAL_SCOPING_SCREEN) && {appId},
      }
    });
    return {
      data: response.data,
      apis,
      appId,
      caller
    };
  }
);

export const selectedDMSSlice = createSlice({
  name: 'selectedDMSSlice',
  initialState,
  reducers: {
    updateDMS: (state, action) => {
      const { location, dmsAccount, departments, cmfNumber, dmsAccountType, entityId, type, id } = action.payload;
      let dmsExist = state.selectedDMS.filter(ele =>
            ele.location === location &&
            ele.cmfNumber === cmfNumber &&
            ele.dmsAccountType === dmsAccountType &&
            ele.entityId === entityId &&
            ele.type === type &&
            ele.id === id
          );
      if(dmsExist.length){
        const elementsIndex = state.selectedDMS.findIndex(ele =>
          ele.location === location &&
          ele.cmfNumber === cmfNumber &&
          ele.dmsAccountType === dmsAccountType &&
          ele.entityId === entityId &&
          ele.type === type &&
          ele.id === id
        )

        let newArray = [...state.selectedDMS]
        newArray[elementsIndex] = {
          ...newArray[elementsIndex],
          dmsAccount,
          departments
        }
        state.selectedDMS = newArray
      } else {
        state.selectedDMS.push(action.payload);
      }
    },
    removeDMS: (state, action) => {
      let selectedDMSAccount = state.selectedDMS;
      const { location, type, id } = action.payload;
      selectedDMSAccount =
        selectedDMSAccount &&
        selectedDMSAccount.filter(
          item =>
            item.location !== location ||
            item.type !== type ||
            item.id !== id
        );
      state.selectedDMS = selectedDMSAccount;
    },
    updateSelectedDMSAccounts: (state, action) => {
      state.updatedSelectedLocations = action.payload;
    },
    updateDMSAccountsOnSelection: (state, action) => {
      state.selectedDMS = action.payload;
    },
    updateDMSAccountsForAllLocations: (state, action) => {
      state.updatedSelectedAllLocations = action.payload;
    },
    showAllDMSAccountsLocations: (state, action) => {
      state.showAllLocations = action.payload;
    },
    setDealerApiPreferences: (state, action) => {
      state.dealerApiPreferences = action.payload;
    },
    clearDMS: state => {
      state.selectedDMS = [];
      state.getEISDMSInfo = [];
      state.updatedSelectedLocations = [];
      state.updatedSelectedAllLocations = [];
      state.DMSConfigInfo = [];
      state.dmsApiDetails = {};
      state.showAllLocations = [];
      state.dealerApiPreferences = {};
    },
    clearSelectedDMS: state => {
      state.selectedDMS = [];
    }
  },
  extraReducers: {
    [getDMSAccountDetailsFromEIS.fulfilled]: (state, action) => {
      const {
        data,
        location,
        cmfNumber,
        entityId,
        dmsApiDetails
      } = action.payload;

      let dealerStoresData = data || {};
      const dept = [];
        Object.keys(dealerStoresData).length > 0 &&
        dealerStoresData &&
        dealerStoresData.departments &&
        dealerStoresData.departments.length &&
        dealerStoresData.departments.map(department => {
            const filteredDmsTypeValue = Object.entries(DMS_ACCOUNT_TYPES_MAPPING)
              .map(([key, value]) => {
                if(department.type && department.type.toUpperCase() === key){
                  return value;
                }
              })
              .filter(dmsType => dmsType);
            const apiIdVal = Object.entries(dmsApiDetails)
              .map(([key, value]) => {
                if(value.includes(filteredDmsTypeValue[0])) {
                  return key;
                } else if (value && Array.isArray(value[0]) && value[0].length > 0 && value[0].includes(filteredDmsTypeValue[0])) {
                  return key;
                }
              })
              .filter(apiId => apiId);
            dept.push({
              // this seeds the structure for the dmsAccount field
              id: `${dealerStoresData.id}-${department.id}`,
              location,
              cmfNumber,
              dmsAccount: department.name,
              dmsAccountType: department.type,
              departments: [
                { name: department.name, id: department.id }
              ],
              entityId,
              api: apiIdVal || ''
            })
          })

      if(!dealerStoresData.departments.length) {
        dept.push({
          id: `${dealerStoresData.id}-dept-demo`,
          location,
          cmfNumber,
          dmsAccount: '',
          dmsAccountType: '',
          departments: [],
          entityId,
          api: ''
        })
      }

      const dmsAccountsArray = Object.entries(
        dept.reduce((a, {entityId, departments}) => {
          a[entityId] = (a[entityId] || []).concat(departments);
          return a;
        }, {})
      ).map(([entityId, departments]) => ({
        entityId,
        departments,
        dmsAccount: departments.map(d => d.name)
      }));

      const deptWithApiIds = dept.filter(item => item.api);
      const dmsData = [];
      deptWithApiIds.map(item => {
        const dmsAccount = item.dmsAccount;
        const entry = dmsAccountsArray.find(ele => ele.entityId === item.entityId);
        if (entry) {
          const dms = entry.dmsAccount.filter(item => item !== dmsAccount);
          item.dmsAccount = [dmsAccount, ...dms];

          const otherDepts = entry.departments.filter(d => d.name !== dmsAccount);
          item.departments = item.departments.concat(otherDepts);
        }
        dmsData.push(item);
      });

      if (!deptWithApiIds.length && dept.length) {
        Object.entries(dmsApiDetails).map(([key, value]) => {
          dept[0].api = key;
          deptWithApiIds.push(dept[0]);
        });
        deptWithApiIds.map(item => {
          const entry = dmsAccountsArray.find(ele => ele.entityId === item.entityId);
          if (entry) {
            item.dmsAccount = [...entry.dmsAccount];
            item.departments = [...entry.departments];
          }
          dmsData.push(item);
        });
      }
      const updatedLocations = [...state.getEISDMSInfo, ...dmsData];

      const updatedUniqueLocations = [
        ...new Map(
          updatedLocations.map(item => [item['id'], item])
        ).values()
      ];
      state.getEISDMSInfo = updatedUniqueLocations;
      state.isEISDMSInfoSuccess = true;
      state.isEISDMSInfoPending = false;
      state.isEISDMSInfoLoading = false;
    },
    [getDMSAccountDetailsFromEIS.pending]: (state, action) => {
      state.isEISDMSInfoPending = true;
      state.isEISDMSInfoLoading = true;
    },
    [getDMSAccountDetailsFromEIS.rejected]: (state, action) => {
      state.isEISDMSInfoSuccess = false;
      state.isEISDMSInfoPending = true;
      state.isEISDMSInfoLoading = false;
      state.errorInGetEISDMSInfo = action.error;
    },
    [getDMSInfoBasedOnApis.fulfilled]: (state, action) =>{
      state.getDMSInfoBasedOnApisPending = false;
      if (action.payload) {
        const { data: { dmsTypes, apiDetails, privacyProtectionSupported, verticalScopingApisList, dealerApiPreferences }, appId, caller} = action.payload;
        const fieldLimitingEnabledVSApis = verticalScopingApisList?.filter(api => api.fieldLimiting);
        if(caller === 'CustomContextMenu') {
          state.dmsSupported = {
            ...state.dmsSupported,
            [appId]: !!dmsTypes.length
          }
          state.verticalScopingSupported = {
            ...state.verticalScopingSupported,
            [appId]: fieldLimitingEnabledVSApis
          }
          return;
        }
        state.DMSConfigInfo = dmsTypes;
        state.dmsApiDetails = apiDetails
        state.privacyProtectionSupported = privacyProtectionSupported;
        state.verticalScopingApisList = fieldLimitingEnabledVSApis;
        state.dealerApiPreferences = dealerApiPreferences || {};
      }
    },
    [getDMSInfoBasedOnApis.pending]: state => {
      state.getDMSInfoBasedOnApisPending = true;
      state.getDMSInfoBasedOnApisError = null;
    },
    [getDMSInfoBasedOnApis.rejected]: (state, { error }) =>{
      state.getDMSInfoBasedOnApisPending = false;
      state.getDMSInfoBasedOnApisError = error;
    }
  }
});

export const {
  updateDMS,
  removeDMS,
  updateSelectedDMSAccounts,
  updateDMSAccountsOnSelection,
  updateDMSAccountsForAllLocations,
  showAllDMSAccountsLocations,
  setDealerApiPreferences,
  clearDMS,
  clearSelectedDMS
} = selectedDMSSlice.actions;

export default selectedDMSSlice.reducer;
